/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DataState } from '../types/common/DataState';

const isEveryInState = (states: DataState[], neededState: DataState): boolean => states.every(v => v === neededState);

export const isDataNotAsked = (...values: DataState[]) => isEveryInState(values, DataState.notAsked);
export const isDataLoading = (...values: DataState[]) => isEveryInState(values, DataState.loading);

export const dataNotAsked = (): DataState => DataState.notAsked;
export const dataLoading = (): DataState => DataState.loading;
export const dataLoaded = (): DataState => DataState.loaded;
export const dataError = (): DataState => DataState.error;
